import { formatCurrency, formatDate } from '../../../../../utils/formatUtils';
import { Panel } from 'primereact/panel';
import { useFormContext } from 'react-hook-form';
import FormInfo from '../../../../components/messages/FormInfo';
import {
  APTransactionEntryForm,
  APTransactionEntryGLItem,
  APTransactionEntryJobItem,
} from '../../../../Interfaces/Accounting/ACForms.interfaces';
import { useCompanyContext } from '../../../../context/CompanyContext';
import { useQuery } from '@tanstack/react-query';
import { fetchVendors } from '@/src/app/services/accounting/vendorsService';
import { APVendor } from '@/src/app/Interfaces/Accounting/AccountsPayables.interfaces';
import APItemSummary from './APItemSummary';

const APEntrySummary = () => {
  const { selectedCompany } = useCompanyContext();
  const { getValues } = useFormContext<APTransactionEntryForm>();
  const {
    vendorType,
    vendor,
    number,
    date,
    description,
    total,
    items,
    prevAttachment,
  } = getValues();

  const vendors = useQuery({
    queryKey: ['getAPEntryVendors', selectedCompany, vendorType],
    queryFn: ({ signal }) => {
      return fetchVendors(
        {
          company: selectedCompany!,
          active: true,
          types: [vendorType as string],
        },
        signal
      );
    },
    refetchOnWindowFocus: false,
    enabled: false,
  });

  return (
    <Panel header="Info" className="max-w-600px mx-3 text-standard">
      <div className="grid">
        <div className="col-12 sm:col-6">
          <FormInfo label="Vendor Type" content={vendorType} />
        </div>
        <div className="col-12 sm:col-6">
          <FormInfo
            label="Vendor"
            content={
              vendors.data?.find(
                (vendorData: APVendor) => `${vendorData.code}` === vendor
              )?.name ?? '-'
            }
          />
        </div>
        <div className="col-12 sm:col-6">
          <FormInfo label="Invoice Number" content={number} />
        </div>
        <div className="col-12 sm:col-6">
          <FormInfo
            label="Invoice Date"
            content={date ? formatDate(date) : '-'}
          />
        </div>
        <div className="col-12 sm:col-6">
          <FormInfo label="Invoice Description" content={description} />
        </div>
        <div className="col-12 sm:col-6">
          <FormInfo
            label="Invoice Total"
            content={formatCurrency(total ?? 0)}
          />
        </div>
        <div className="col-12 sm:col-6">
          <FormInfo label="Attachment" content={prevAttachment ?? '-'} />
        </div>
        <div className="col-12 sm:col-6 printHide" />
        {items?.length && (
          <div className="col-12">
            <FormInfo label="Items" content="" />
            {items.map((item, index) => {
              return (
                <APItemSummary
                  key={index}
                  item={
                    item as APTransactionEntryJobItem | APTransactionEntryGLItem
                  }
                  index={index}
                />
              );
            })}
          </div>
        )}
      </div>
    </Panel>
  );
};

export default APEntrySummary;
